// п. 23 (`DEV-68`, ФЗ-152, РГ-08 ред. 2.1). Внесение пользователя по договору и
// работа с приглашением — маршруты бэкенда из п. 11 (`DEV-65`/`DEV-65.1`):
//
//   POST /users/invite                 { email, contractNumber, contractDate, machinePlaceId }
//   POST /users/:id/invite/resend      → { userId, invitationSent }
//   POST /users/:id/invite/revoke      → { userId, state }
//
// Маршруты закрыты ролью `root` (`DEV-65.1`, `АУД-Н96`).

import $api from "../http";
import { AxiosResponse } from "axios";

export interface IInviteUser {
  email: string;
  contractNumber: string;
  /** Дата договора обязательна (`РГ-08`): без неё основание хранения неполно. */
  contractDate: string;
  machinePlaceId: number;
  companyId?: number | null;
}

export interface IInvitationAnswer {
  userId: number;
  linkId: number;
  placeId: number;
  state: string;
  invitationSent: boolean;
}

export default class InvitationService {
  static invite(data: IInviteUser): Promise<AxiosResponse<IInvitationAnswer>> {
    return $api.post<IInvitationAnswer>("/users/invite", data);
  }

  static resend(
    userId: number,
  ): Promise<AxiosResponse<{ userId: number; invitationSent: boolean }>> {
    return $api.post(`/users/${userId}/invite/resend`);
  }

  static revoke(
    userId: number,
  ): Promise<AxiosResponse<{ userId: number; state: string }>> {
    return $api.post(`/users/${userId}/invite/revoke`);
  }
}
